import { Injectable } from '@angular/core';
import { NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { StudentEventModel } from 'src/lib/services/api/students/events/student-event.model';
import { ModalService } from 'src/lib/services/utility/modal/modal.service';
import { StudentEventDetailModalComponent } from './student-event-detail-modal.component';

@Injectable({
	providedIn: 'root',
})
export class StudentEventDetailModalService {
	private _openModals = new Map<number, NgbModalRef>();

	constructor(private modalService: ModalService) {}

	public openModal$(
		studentId: number,
		eventId: number,
		edit?: Partial<StudentEventModel>,
	) {
		return new Observable<boolean>((o) => {
			if (!this._openModals.has(eventId)) {
				const ngbModalOptions: NgbModalOptions = {
					backdrop: 'static',
					keyboard: false,
					size: 'lg',
				};

				const modal = this.modalService.open(
					StudentEventDetailModalComponent,
					ngbModalOptions,
					{
						studentId: studentId,
						eventId: eventId,
						editEvent: edit,
					},
				);

				modal.result
					.then((value) => {
						o.next(value);
						o.complete();
					})
					.catch(() => {
						o.next(false);
						o.complete();
					})
					.finally(() => {
						this._openModals.delete(eventId);
					});

				this._openModals.set(eventId, modal);
			} else {
				o.next(false);
				o.complete();
			}
		});
	}

	public closeModal(_studentId: number, eventId: number) {
		if (this._openModals.has(eventId)) {
			this._openModals.get(eventId).dismiss();
		}
	}
}
